import React from 'react';
import { SVGIconProps } from './props';

const PhoneSVGIcon = (props: SVGIconProps) => {
    return (
        <span className={props.className}>
            <svg width='14' height='24' viewBox='0 0 14 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M1.2517 5.93676C-0.00289012 6.75041 -0.249325 9.29381 0.224286 11.3668C0.593184 12.9811 1.37746 15.1465 2.69994 17.1856C3.94405 19.1039 5.67976 20.8239 7.00324 21.8191C8.70276 23.0969 11.1255 23.9091 12.3801 23.0955C13.0145 22.684 13.957 21.5599 14 21.3582C14 21.3582 13.4473 20.506 13.326 20.319L11.4726 17.4613C11.3348 17.2489 10.4711 17.443 10.0323 17.6916C9.44042 18.0269 8.89531 18.9268 8.89531 18.9268C8.48945 19.1612 8.14955 18.9276 7.4393 18.6008C6.56641 18.1992 5.58497 16.9512 4.8039 15.821C4.09049 14.6469 3.35132 13.2418 3.34057 12.281C3.33178 11.4992 3.25713 11.0936 3.63668 10.8187C3.63668 10.8187 4.68061 10.6879 5.2282 10.2843C5.63406 9.98504 6.16357 9.27556 6.02583 9.06321L4.17242 6.20543C4.05115 6.01842 3.49844 5.16626 3.49844 5.16626C3.29684 5.12321 1.88607 5.52532 1.2517 5.93676Z'
                    fill='#31599A'
                />
                <path
                    d='M11.7593 8.06923C12.5136 4.99503 10.7215 1.85135 7.69189 0.934184L7.94771 0C11.4925 1.05857 13.5886 4.73551 12.6935 8.32504L11.7593 8.06923Z'
                    fill='#31599A'
                />
                <path
                    d='M9.73497 7.51506C10.1853 5.55703 9.05198 3.5689 7.1377 2.95892L7.3936 2.02441C9.82299 2.77625 11.2602 5.29747 10.6695 7.77097L9.73497 7.51506Z'
                    fill='#31599A'
                />
                <path d='M7.70721 6.95946C7.85762 6.11897 7.3819 5.28442 6.58203 4.98565L6.83844 4.04932C8.15245 4.49278 8.93138 5.85922 8.64354 7.21587L7.70721 6.95946Z' />
            </svg>
        </span>
    );
};

export default PhoneSVGIcon;
